import { SessionsAPI } from "../infrastructure/api/sessions.api";

/** Passages of a session's notes the therapist marked to keep in view. */

export async function listSessionHighlights(sessionId: string) {
    const { data } = await SessionsAPI.getHighlights(sessionId);
    return data;
}

/** Highlights across all of a patient's sessions. */
export async function listPatientHighlights(patientId: string) {
    const { data } = await SessionsAPI.getPatientHighlights(patientId);
    return data;
}

export async function createSessionHighlight(sessionId: string, highlight: { text: string; patient_id: string }) {
    const { data } = await SessionsAPI.createHighlight(sessionId, highlight);
    return data;
}

export async function deleteSessionHighlight(highlightId: string): Promise<void> {
    await SessionsAPI.deleteHighlight(highlightId);
}
